<template>
  <div class="text-center d-flex flex-column" style="max-width: 550px; gap: 20px">
    <div>
      <article class="icon">
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 3L2 6M22 6L19 3M6 19L4 21M18 19L20 21M12 9V13L14 15M12 21C14.1217 21 16.1566 20.1571 17.6569 18.6569C19.1571 17.1566 20 15.1217 20 13C20 10.8783 19.1571 8.84344 17.6569 7.34315C16.1566 5.84285 14.1217 5 12 5C9.87827 5 7.84344 5.84285 6.34315 7.34315C4.84285 8.84344 4 10.8783 4 13C4 15.1217 4.84285 17.1566 6.34315 18.6569C7.84344 20.1571 9.87827 21 12 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </article>
    </div>
    <h2 style="font-weight: 500;">{{ $t('emptyLink.expiredLink') }}</h2>
    <h3 class="font-weight-regular text--secondary" v-html="message"></h3>
    <v-btn
      color="primary"
      :href="buttonLink"
      role="button"
      elevation="0"
      v-html="buttonText"
      style="height: 45px; border-radius: 10px;"
    ></v-btn>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
require('@/plugins/OcularMoment')

@Component({
  props: {
    content: {
      type: Object,
      default: null
    }
  }
})
export default class ExpiredLink extends Vue {
  get buttonLink() {
    return this.content.organization.hostName
  }

  get buttonColor() {
    return this.content.organization.primaryColor ?? 'primary'
  }

  get buttonText() {
    return this.$t('emptyLink.goTo', { name : `${this.content.organization.name}` })
  }

  get message() {
    const companyName = this.content.organization.name
    const expirationDate = this.$ocularMoment.timeZoneDate(this.content.date.endDate).format('DD/MM/YYYY HH:mm')

    return this.$t('emptyLink.message', {
      status: `<b>${this.$t('emptyLink.status.expired')}</b>.`,
      company: `<b>${companyName}</b>`,
      additionalInfo: this.$t('emptyLink.additionalInfo.expired', { expirationDate: `<b>${expirationDate}</b>` }),
    })
  }
}
</script>

<style scoped>
.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 1px solid #e0e0e0;
  margin: 0 auto;
}

.icon svg {
  width: 45px;
  fill: none;
  stroke: #000;
  color: #676767;
}
</style>
